module.exports = __webpack_public_path__ + "static/img/9.473861d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/3/9.jpg
// module id = TF8M
// module chunks = 1